import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=0b497158&scoped=true&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=0b497158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b497158",
  null
  
)

export default component.exports